import { styled } from "@pigment-css/react";

export const SHELL_CONTROL_ROW_BOTTOM_PX = 120;

export const ListHeaderAnchor = styled("div")({
  scrollMarginTop: `${SHELL_CONTROL_ROW_BOTTOM_PX}px`,
});
